import {
    Box,
    Divider,
    LinearProgress,
    Typography,
    useTheme,
} from "@mui/material";
import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import CustomLabelLine from "../../../components/charts/CustomLabelLine";
import Legends from "../../../components/legends/Legends";
import TileBox from "../../../components/tile/TileBox";
import { useStyles } from "./styles";

const OverallReport = ({ data }) => {
  const classes = useStyles();
  const theme = useTheme();

  const graphData = [
    {
      label: "Non-Terraform Managed",
      value: data?.manually_created,
      color: theme.palette.blue[3],
    },
    {
      label: "Terraform Managed ",
      value: data?.terraform_managed,
      color: theme.palette.orange[1],
    },
  ];

  const renderCenterLabel = () => {
    return (
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="middle"
        style={{
          fill: theme.palette.text.primary,
          fontSize: "15px",
          fontWeight: 600,
        }}
      >
        Total: {data?.total_aws_resource_count}
      </text>
    );
  };

  return (
    <TileBox title="Overall">
      <Box className={classes.root}>
        <Box className={classes.chartContainer}>
          <ResponsiveContainer width="70%" height="100%">
            <PieChart>
              <Pie
                data={graphData}
                dataKey="value"
                cx="50%"
                cy="50%"
                innerRadius={45}
                outerRadius={85}
                label={
                  <CustomLabelLine
                    totalValue={data?.total_aws_resource_count}
                  />
                }
                labelLine={{
                  strokeWidth: 1,
                  strokeDasharray: "1,1",
                }}
              >
                {graphData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              {renderCenterLabel()}
            </PieChart>
          </ResponsiveContainer>
          <Legends legends={graphData} />
        </Box>
        <Divider />
        <>
          <Box my={1} display="flex" justifyContent="space-between">
            <Typography>Automation Percentage </Typography>
            <Typography>{data?.automation_percentage}%</Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={data?.automation_percentage}
            color="secondary"
            sx={{
              height: 12,
              borderRadius: 6,
              backgroundColor: (theme) => theme.palette.grey[200],
            }}
          />
        </>
      </Box>
    </TileBox>
  );
};

export default OverallReport;
